import { ComisionesF } from "@/cuentas/ComisionesF";
import { useConfigContext } from "@/state/configContext";
import { assert } from "@/helpers/helpers";
import { useAdminContext } from "@/state/adminContext";
import { GET } from "@/state/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/miscomisiones")({
  component: RouteComponent,
  loader: async () => (await GET("/admin/miscomisiones")).miscomisiones,
});

function RouteComponent() {
  const { admin } = useAdminContext();
  const config = useConfigContext();
  const data = Route.useLoaderData();

  const temporada_id = config.temporada;
  assert(admin.id);

  return <ComisionesF {...{ data, fotografo_id: admin.id, temporada_id }} />;
}
